import { render, staticRenderFns } from "./booking-details-tab-history.vue?vue&type=template&id=cebad97c&"
import script from "./booking-details-tab-history.vue?vue&type=script&lang=js&"
export * from "./booking-details-tab-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports